import React from "react";
import { BoxDanger, MSection } from "components/misc";
import { Row, Col } from "design-react-kit";
import { networkErrorHelper, pageService } from "libs";
import { FormEnabler, ValidatedForm, MInput, MCheckbox } from "components/forms";
import { MASTERS } from "../master-medicina/master-data";

export class FormMasterUnicamillus extends ValidatedForm {
  constructor(props) {
    super(props);
    const initialValues = { ...this.emptyFields, masterCode: props.masterCode || "" };
    this.state = {
      ...initialValues,
      defaultValues: { ...initialValues },
      formActive: true,
      isSuccess: 0,
      submittedMasterCode: null,
      type: "master_unicamillus",
    };
  }

  emptyFields = {
    masterCode: "",
    name: "",
    surname: "",
    email: "",
    mobile: "",
    officeCode: "",
    accept: false,
  };

  ERROR_MESSAGES = {    
    name: "Inserisci il tuo nome",
    surname: "Inserisci il tuo cognome",
    email: "Inserisci la tua email",
    mobile: "Inserisci il tuo numero di telefono",
    accept: "Accetta la privacy policy per continuare",
    officeCode: "Inserisci il codice riservato",
  };

  validation = {   
    name: (value) => value && value.trim() !== "",
    surname: (value) => value && value.trim() !== "",
    email: (value) => value && /\S+@\S+\.\S+/.test(value),
    mobile: (value) => value && value.trim() !== "",
    officeCode: (value) => value && value.trim() !== "",
    accept: (value) => value === true,
  };

  FIELDS_GROUP = [    
    [
      {
        id: "name",
        field: "name",
        label: "Nome",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        id: "surname",
        field: "surname",
        label: "Cognome",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "email",
        field: "email",
        label: "Email",
        component: MInput,
        type: "email",
        className: "col-md-6",
      },
      {
        id: "mobile",
        field: "mobile",
        label: "Cellulare",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "officeCode",
        field: "officeCode",
        label: "Codice riservato",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "accept",
        field: "accept",
        label:
          'Dichiaro di aver letto la <a href="/page/privacy-policy" className="link-dark" target="_blank" rel="noopener noreferrer">Privacy Policy</a>  ai sensi del Regolamento UE 2016/679 (GDPR)',
        component: MCheckbox,
        className: "col-md-12",
      },
    ],
  ];

  saveRemote = () => {
    const { type } = this.state;
    const masterCode = this.getValueField("masterCode");
    const submittedMaster = MASTERS.find((master) => master.code === masterCode);

    const payload = {
      name: this.getValueField("name"),
      surname: this.getValueField("surname"),
      email: this.getValueField("email"),
      mobile: this.getValueField("mobile"),
      type,
      metadata: 
        {
          masterCode,
          officeCode: this.getValueField("officeCode"),
          pdfLink: submittedMaster ? submittedMaster.pdfLink : "",
          originalLink: submittedMaster ? submittedMaster.originalLink : "",
        },      
    };

    pageService
      .saveContactRequestMasterMedicina(payload)
      .then(() => {
        this.setState({ isSuccess: 200, submittedMasterCode: masterCode });
      })
      .catch((errors) => {
        if (networkErrorHelper.is422(errors)) {
          this.setState({ isSuccess: 422 });
        }
      });
  };

  onCancel = () => {
    this.resetForm();
  };

  render() {
    const { formActive, defaultValues, isSuccess, submittedMasterCode } = this.state;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, formActive);
    const submittedMaster = MASTERS.find((master) => master.code === submittedMasterCode);

    return (
      <>       

        {isSuccess === 0 && (
          <>
            <MSection className="my-3">
              <p>Cliccando su <b>Salva</b> riceverà tutte le info inerenti il master senza nessun impegno o vincolo all'iscrizione. </p>
              <Row className="my-3">
                <Col>
                  <form className="user" id="masterunicamillusform">
                    {code}
                  </form>

                  <div className="mt-2">
                    <FormEnabler onSubmit={this.onSubmit} onCancel={this.onCancel} onToggle={this.toggleForm} isFormActive={formActive} />
                  </div>
                </Col>
              </Row>
            </MSection>
          </>
        )}

        {isSuccess === 200 && (
          <MSection className="my-3">
            <p className="mt-3">Grazie per aver inviato l'adesione<br/></p>           
            {submittedMaster && <>
            <p>La invitiamo a prendere visione della scheda informativa e della pagina dedicata:</p>
            <a
              href={submittedMaster.pdfLink}
              className="btn btn-primary bg-dark m-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Scheda informativa
            </a>
            <a
              href={submittedMaster.originalLink}
              className="btn btn-primary bg-dark m-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Pagina dedicata
            </a>
            <p>Le abbiamo inviato una mail di conferma con i link sopra indicati.

            </p>
            </>}
          </MSection>
        )}

        {isSuccess === 422 && (
          <MSection className="my-3">
            <BoxDanger>
              <p className="mb-0">
                Gentile Insegnante, <br />è già presente una richiesta con i dati inseriti.
              </p>
            </BoxDanger>
          </MSection>
        )}
      </>
    );
  }
}
